export const CREATE_EDOK_FORM_REQUEST = 'CREATE_EDOK_FORM_REQUEST';

export const createEdokFormRequest = ( formData ) => ({
    type: CREATE_EDOK_FORM_REQUEST,
    payload: { ...formData },
});
